import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";

// Main edited table component
import Table from "views/Tables/snapshotTable.js";

import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import { cardTitle } from "assets/jss/material-dashboard-pro-react.js";
//import axios from "axios";

// Data for server Req
// Provide JWT token and id in req.body
/*
const JWT = localStorage.getItem("token");
const apiURL = "http://localhost:3000/api/snapshots/history";
const authData = { id: localStorage.getItem("id") };
// add JWT token to ser Req header
axios.interceptors.request.use(
  (config) => {
    config.headers.authorization = `Bearer ${JWT}`;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
*/
const styles = {
  customCardContentClass: {
    paddingLeft: "0",
    paddingRight: "0",
  },
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px",
  },
  textCenter: {
    textAlign: "center",
  },
  cardHeader: {
    marginBottom: "20px",
  },
};

const useStyles = makeStyles(styles);

export default function RegularTables() {
  const classes = useStyles();

  // Req snapshot history
  // 404 server not complete?
  /*
  React.useEffect(() => {
    axios.post(`${apiURL}`, authData).then(
      (response) => {
        console.log(response);
      },
      (error) => {
        console.log(error);
      }
    );
  }, []);
*/
  return (
    <GridContainer>
      <GridItem xs={11} style={{ margin: "auto" }}>
        <Card>
          <CardHeader
            className={`${classes.cardHeader} ${classes.textCenter}`}
            color="primary"
            style={{
              padding: "10px",
            }}
          >
            <h4
              style={{
                fontFamily: "Arial",
                color: "#fff",
                fontWeight: "500",
                fontSize: "18px",
              }}
            >
              Employee Assessment Overview
            </h4>
          </CardHeader>
          <CardBody>
            <Table
              tableHeaderColor="primary"
              tableHead={["Date", "Status", "Points"]}
              tableData={[
                ["23/02/2020", "Completed", ""],
                ["23/02/2020", "Completed", ""],
                ["23/02/2020", "Completed", ""],
                ["23/02/2020", "Completed", ""],
              ]}
              coloredColls={[3]}
              colorsColls={["primary"]}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
}
